var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-row',[_c('ion-col',[_c('button',{staticClass:"prime-button button-block enroll-button",class:{ 'button-pending': _vm.isLoading },attrs:{"type":"submit"},on:{"click":_vm.handleClick}},[_c('span',[_vm._v(_vm._s(_vm.submitButtonText))]),_c('ion-spinner',{attrs:{"name":"dots","duration":"1200"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }